import request from '@/router/axios'

const API = '/api/twin/emergency-plan-screen'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function fetchEmergencyPlanScreen(params = {}) {
  return request({
    url: `${API}/display`,
    method: 'get',
    params
  }).then(unwrap)
}
